import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import withCurrency from '../../../containers/withCurrency';

const CartItemPrice = ({
  amount,
  extraClass,
  formatCurrencyForCalculation,
}) => <div className={extraClass}>{formatCurrencyForCalculation(amount)}</div>;

CartItemPrice.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  extraClass: PropTypes.string,
  formatCurrencyForCalculation: PropTypes.func.isRequired,
};

CartItemPrice.defaultProps = {
  extraClass: '',
};

export default withCurrency(observer(CartItemPrice));
